import type { FaireProductEntity } from "../../entity_types/product";

export const p_w58ebm5nfa: FaireProductEntity = {
  token: "p_w58ebm5nfa",
  type: "product",
  name: "House Rules Hanging Decor",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/77ca2cac71ff12be27e12de6197ceec5e8b565b672a7622972c71432e7dffa2c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/25de7ae0e30ba9b59aa88d90c9bd50d499dd6f86232927162321ef89b71749aa.jpeg",
    "https://cdn.faire.com/fastly/fab4dae9241f816ce75ea4b7ef168a0d34773938bc9422af5dc8022f3480f7e2.jpeg",
    "https://cdn.faire.com/fastly/340bd73f5b0889fe4a7daab187fe4eaab75b9a2b1b0a8d51cfc280c5d09e91b2.jpeg"
  ],
  priceDollars: 5,
  description: "A ready to hang metal tin sign from our Slow Living Collection displaying a hand illustrated design of \"House Rules\" perfect for those who enjoy cozy home life. Cozy living sign features metal with embossed details for added dimension. Our House Rules metal wall décor is easy to hang against wall using the included mounting hardware and pre-drilled holes. A cozy living home accent that easily adds personality to any space.",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:39.675Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
